import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { SStrapiService, useCmsLocaleReload } from '@slg/web-customer-shared';
import TwoColumnInfo from '@/components/strapi/TwoColumnInfo.vue';
import AdditionalInfo from '@/components/strapi/AdditionalInfo.vue';


import { getMetaInfo } from '@/utils/seo';

const __default__ = {
  name: 'AboutPage',
  metaInfo() {
    return getMetaInfo((this as { aboutPageData?: { Seo?: unknown } }).aboutPageData?.Seo);
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const aboutPageData = ref<Record<string, any> | null>(null);
const test = ref(null);

async function loadCmsData() {
  try {
    aboutPageData.value = await SStrapiService.getAbout();
  } catch (error) {
    // to-do rethink about catch
  }
}

useCmsLocaleReload(loadCmsData);

return { __sfc: true,aboutPageData, test, loadCmsData, TwoColumnInfo, AdditionalInfo }
}

})